<template lang="pug">
#PageResultDeviceHistory
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Device History" :HeaderGlobalBreadcrumb="breadcrumb")

    //- banner filter
    ResultFilter

    .box
        header.flex.items-center.justify-between.box__header.no-border
            .header-meta
                h2.subheading Devices History List
            .header-cta

        .box__body.p-4
            template(v-if="load_data_status_device_history.status === 'loading'")
                Loading(show="true")

            template(v-else)
                .flex.flex-wrap.-mx-3(v-if="device_history && Object.keys(device_history).length > 0")
                    .block.p-3(class="w-full lg:w-2/6" v-for="(device,index) in device_history" :key="index")
                        .block
                            .block.border.p-3.rounded
                                .block.mb-2.pb-2.border-b.border-dashed
                                    .flex.items-center.justify-between
                                        .block
                                            small.fons-sx.text-gray-500.block.mb-2
                                                | NEW DEVICE • {{ device.datetime }}
                                            small.inline-block.font-bold.bg-green-200.text-green-800.rounded.py-1.px-2.mb-2(style="font-size:65%") {{ device.event }}
                                            span.block {{ device.new_device_name }} ({{ device.new_device_vendor }})
                                            span.monospace.font-bold
                                                | IMEI {{ device.new_imei }}
                                        .block
                                            button.btn-default.btn-icon(v-tooltip="device.new_device_tags.length > 0 ? device.new_device_tags.join(', ') : '---'")
                                                //- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                .block
                                    .flex.items-center.justify-between
                                        .block
                                            small.fons-sx.text-gray-500 PREV DEVICE
                                            span.block {{ device.prev_device_name }} ({{ device.prev_device_vendor }})
                                            span.monospace.font-bold IMEI {{ device.prev_imei }}
                                        .block
                                            button.btn-default.btn-icon(v-tooltip="device.prev_device_tags.length > 0 ? device.prev_device_tags.join(', ') : '---'")
                                                //- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                
                //- template(v-else) Data Not Found
                NoDataAvailable(v-else)

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import ResultFilter from './ResultFilter.vue';

export default {
    name: 'DeviceHistory',
    components: {
        Loading,
        NoDataAvailable,
        HeaderGlobal,
        ResultFilter,
    },
    props: ['resultGlobalBreadcrumb'],
    data: function () {
        return {
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Device History',
                    url: '/result/device-history',
                },
            ],
            historyDevices: [
                {
                    id: 1,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
                
                {
                    id: 2,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
                {
                    id: 3,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
                {
                    id: 4,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
                {
                    id: 5,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
                {
                    id: 6,
                    dateChange: '2020/1/20',
                    newDevice: {
                        name: 'Iphone 8s',
                        phone: '987354657687980',
                    },
                    lastDevice: {
                        name: 'Galaxy s7',
                        phone: '987354655676890',
                    }
                },
            ]
        }
    },
    computed: {
        ...mapState([
            'load_data_status_device_history',
            'device_history',
        ]),
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        }
    },
    mounted() {
        // console.log('=============== mounted on DeviceHistory.vue');
        // this.$store.dispatch('getDeviceHistory');
    }
}
</script>

<style lang="sass">
</style>
